module.exports = __webpack_public_path__ + "images/stickers/pete-broken.e0c1fadd8cdf3173a4cf.png";